// 隐私处理手机号
export function privacyAccount(account: string) {
  if (account) {
    return account.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
  }
  return account;
}

/** 提取手机号后四位（用于下拉列表区分成员） */
export function extractPhoneLast4(account: string): string {
  if (!account) return "";
  const digits = account.replace(/\D/g, "");
  return digits.slice(-4);
}

export function privacyEmail(email: string) {
  if (!email || email.indexOf("@") === -1) {
    // 如果邮箱格式不正确，则直接返回原字符串或进行错误处理
    return email;
  }

  const parts = email.split("@");
  const username = parts[0];
  const domain = parts[1];

  if (username.length <= 2) {
    // 如果用户名长度小于等于2，例如 "a@b.com" 或 "ab@c.com"
    // 规则可能是显示 "**@domain"
    // 或者根据具体需求调整，这里我们姑且认为至少显示两个星号
    return "**@" + domain;
  } else if (username.length === 3) {
    // 如果用户名长度为3，例如 "abc@d.com" -> "**c@d.com"
    return "**" + username.substring(2) + "@" + domain;
  } else {
    let maskedUsername;
    if (username.length === 1) {
      maskedUsername = "*"; // 或者 '**'
    } else if (username.length === 2) {
      maskedUsername = "**";
    } else if (username.length === 3) {
      maskedUsername = "**" + username.charAt(2);
    } else {
      // username.length >= 4
      maskedUsername = "**" + username.substring(2, 4);
    }
    return maskedUsername + "@" + domain;
  }
}
